'use client';

import H2 from '@/components/typography/h2';
import P from '@/components/typography/p';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

export default function History({
    localizationKey,
}: {
    localizationKey: string;
}) {
    const { t } = useTranslation();

    const title = t(`${localizationKey}.title`);

    return (
        <>
            {/* Desktop view */}
            <div className="hidden lg:block">
                <div className="border-primary relative flex flex-col items-center justify-center gap-5 border-b px-6 lg:py-52">
                    <div className="flex gap-3">
                        <div className="relative w-5/12">
                            <Image
                                src="/images/about/frame.png"
                                alt="Good Food"
                                className="absolute right-[-2rem] z-10 h-auto max-h-[800px] w-auto object-scale-down xl:bottom-[-13rem] 2xl:bottom-[-18rem]"
                                width={1024}
                                height={1024}
                            />
                        </div>
                        <div className="w-6/12">
                            <div className="flex flex-col gap-5 pr-[10.5rem]">
                                <H2>{title}</H2>
                                <P
                                    variant="large"
                                    dangerouslySetInnerHTML={{
                                        __html: t(`${localizationKey}.text`),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile view */}
            <div className="relative block lg:hidden">
                <div
                    className={cn(
                        'border-primary relative flex h-auto flex-col items-start justify-center gap-5 border-b px-5 py-15',
                    )}
                >
                    <H2 className="">{title}</H2>
                    <div className={cn('mb-12 w-full lg:w-9/12')}>
                        <P
                            className="flex w-full flex-col gap-3 whitespace-pre-line"
                            dangerouslySetInnerHTML={{
                                __html: t(`${localizationKey}.text`),
                            }}
                        />
                    </div>
                </div>
                <figure
                    className={cn(
                        'absolute right-0 bottom-[-8.5rem] z-10 aspect-square h-[250px] w-auto max-w-full overflow-hidden lg:bottom-[-17.5rem] lg:h-[530px]',
                    )}
                >
                    <Image
                        src="/images/stickers/appel.png"
                        alt="About Us"
                        width={1600}
                        height={1600}
                        className="translate-x-[3rem] object-contain"
                    />
                </figure>
            </div>
        </>
    );
}
